module.exports = __webpack_public_path__ + "static/media/yethi.45ecf090.png";